import { reactive } from 'vue'
import en from './locales/en'
import zhCN from './locales/zh-CN'
import zhTW from './locales/zh-TW'

const messages = { en, 'zh-CN': zhCN, 'zh-TW': zhTW }

export const availableLocales = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'zh-CN', label: '简体中文', short: '简' },
  { code: 'zh-TW', label: '繁體中文', short: '繁' }
]

const STORAGE_KEY = 'ec-locale'

// Map a raw browser language tag to one of our supported locales.
function normalize(tag) {
  if (!tag) return null
  const t = tag.toLowerCase()
  if (t === 'zh-tw' || t === 'zh-hk' || t === 'zh-mo' || t.includes('hant')) return 'zh-TW'
  if (t.startsWith('zh')) return 'zh-CN' // zh, zh-cn, zh-sg, zh-hans...
  if (t.startsWith('en')) return 'en'
  return null
}

// Default to English; otherwise honour a saved choice, then the browser.
function detect() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && messages[saved]) return saved
  } catch (e) { /* localStorage may be unavailable */ }

  const tags = (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || []
  for (const tag of tags) {
    const hit = normalize(tag)
    if (hit) return hit
  }
  return 'en'
}

const state = reactive({ locale: detect() })

function resolve(path, locale) {
  const dict = messages[locale] || messages.en
  return path.split('.').reduce((obj, key) => (obj == null ? undefined : obj[key]), dict)
}

// Translate to a string. Falls back to English, then to the key itself.
export function t(path) {
  const v = resolve(path, state.locale)
  if (v != null) return v
  const fallback = resolve(path, 'en')
  return fallback != null ? fallback : path
}

// Translate to a raw value (object / array). Falls back to English, then [].
export function tm(path) {
  const v = resolve(path, state.locale)
  if (v != null) return v
  const fallback = resolve(path, 'en')
  return fallback != null ? fallback : []
}

export function getLocale() {
  return state.locale
}

export function setLocale(locale) {
  if (!messages[locale]) return
  state.locale = locale
  try { localStorage.setItem(STORAGE_KEY, locale) } catch (e) { /* ignore */ }
  if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', locale)
}

export default {
  install(app) {
    if (typeof document !== 'undefined') document.documentElement.setAttribute('lang', state.locale)
    app.config.globalProperties.$t = t
    app.config.globalProperties.$tm = tm
    app.config.globalProperties.$setLocale = setLocale
    Object.defineProperty(app.config.globalProperties, '$locale', {
      get: () => state.locale
    })
  }
}
